import isDevelopment from "helpers/isDevelopment";
import React, { FunctionComponent, Fragment } from "react";
import { useSelector } from "react-redux";
import DictionaryContent from "./Dictionary.interface";

const Dictionary: FunctionComponent<DictionaryContent> = (props) => {
    const translations = useSelector((state: any) => state.dictionary.translations);
    const fallback = isDevelopment() ? props.name : "";

    return <Fragment>{translations && translations[props.name] ? translations[props.name] : fallback}</Fragment>;
};

export default Dictionary;
